export enum MainTabs {
  NotepadEditor,
  Preview,
  AllComments
}
